import OrganizationIcon from '@forwardflow/assets/svg/OrganizationIcon'
import useAuthUser from '@forwardflow/hooks/customHooks/useAuthUser'
import { useUserNavigation } from '@forwardflow/hooks/customHooks/useUserNavigation'
import { useAppStore } from '@forwardflow/store'
import { useSelectUserOrganizationModalStore } from '@forwardflow/store/modal/SelectUserOrganizationModal'
import { Spinner } from '@forwardflow/ui'

import { Modal } from 'antd'

export const SelectUserOrganizationModal = () => {
   const { setCurrentOrganization, currentOrganization } = useAppStore()
   const {
      isSelectUserOrganizationModalOpen,
      closeSelectUserOrganizationModal,
   } = useSelectUserOrganizationModalStore()
   const { data: user, isLoading } = useAuthUser({ revalidateOnMount: true })
   const { navigateUser } = useUserNavigation()

   const handleSelect = async (orgId: string) => {
      setCurrentOrganization(orgId)
      await navigateUser({
         currentOrgId: orgId,
         searchParams: location.search,
      })
      closeSelectUserOrganizationModal()
   }

   // Only show UI if there are multiple organizations
   if (user?.userOrganizations?.length === 1) return null
   if (isLoading)
      return (
         <div className="min-h-screen flexc">
            <Spinner />
         </div>
      )

   return (
      <>
         <Modal
            className={`ff-modal`}
            title=""
            open={isSelectUserOrganizationModalOpen}
            onCancel={closeSelectUserOrganizationModal}
            footer={null}
         >
            <>
               <div className="flex flex-col items-center w-full">
                  <div className="scale-[2.2] my-4">
                     <OrganizationIcon />
                  </div>

                  <h3 className="my-6 text-2xl font-bold text-center text-[#C3C3C3]">
                     Choose your workspace
                  </h3>
                  <p className="mb-10 text-center">
                     You have access to multiple organizations. <br />
                     Select any organization to switch.
                  </p>
                  <p className="w-full bg-white/20 h-[1px] mb-8"></p>
                  <ul className="w-full space-y-4">
                     {user?.userOrganizations?.map((org: any) => {
                        return (
                           <li
                              onClick={() => handleSelect(org.organizationId)}
                              key={org.organizationId}
                              className="flex items-center  p-2  h-[70px] rounded-md cursor-pointer bg-white/10 hover:bg-white/30"
                           >
                              <span className="bg-[#27282C] w-14 h-14 rounded-lg mr-5 flexc">
                                 <OrganizationIcon />
                              </span>
                              <span className="mr-4 font-medium text-white">
                                 {org.organization.name}
                              </span>
                              {org.organizationId === currentOrganization && (
                                 <span className="text-[#25D657] border border-[#25D657] px-3 pt-0.5 rounded-sm text-[10px] inline-block">
                                    ACTIVE
                                 </span>
                              )}
                           </li>
                        )
                     })}
                  </ul>
               </div>
            </>
         </Modal>
      </>
   )
}
